import { PersonBus } from "./PersonBus";
import { CustomerLogoBus } from "./CustomerLogoBus";
import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { InvoiceChecklistType } from '../../shared/enums/InvoiceChecklistType';

export class CustomerInvoiceChecklistBus extends BaseBus
{
    constructor(data: CustomerInvoiceChecklistBus) {
        super(data);
    }

    CID(): any {
        return this.customerInvoiceChecklistId;
    }
    initialize(data: CustomerInvoiceChecklistBus) {
        super.initialize(data);
        this.insertDt = CommonFunctions.getDate(data.insertDt);
        this.updateDt = CommonFunctions.getDate(data.updateDt);
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: CustomerInvoiceChecklistBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();

        if (this.hasId) {
            //this.updateDt = dateNow;
            this.insertDt = DateFunctions.hasReasonableDateValue(data.insertDt) ? data.insertDt : dateNow;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        // this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        this.updateDt = date;
        if (this.hasId) {
            this.updateUserId = userId;
            this.insertDt = DateFunctions.hasReasonableDateValue(this.insertDt) ? this.insertDt : date;
            this.insertUserId = CommonFunctions.hasGuidValue(this.insertUserId) ? this.insertUserId : userId;
        }
        else {
            this.insertDt = date;
            this.insertUserId = userId;
             this.updateUserId = userId;
        }
    }
    setId(id: any) {
        this.customerInvoiceChecklistId = id;
    }
    customerInvoiceChecklistId: string;
    companyId: string;
    customerId: string;
    sortOrder: number;
    note: string;
    states: any;
    checkListType: number;
    readOnly: boolean;
    insertDt: Date;
    updateDt: Date;
    updateUserId: string;
    insertUserId: string;
    isDragging: boolean = false;
    dragging: boolean = false;
}
